import { render, staticRenderFns } from "./AddCustomOrderButton.vue?vue&type=template&id=989c450a&scoped=true&"
import script from "./AddCustomOrderButton.vue?vue&type=script&lang=js&"
export * from "./AddCustomOrderButton.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomOrderButton.vue?vue&type=style&index=0&id=989c450a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989c450a",
  null
  
)

component.options.__file = "AddCustomOrderButton.vue"
export default component.exports